// extracted by mini-css-extract-plugin
export default {"container":"clientSettlementsDetail_container__mWLRf","iconBox":"clientSettlementsDetail_iconBox__gV01M","header":"clientSettlementsDetail_header__4nJs8"};